<template>
  <b-tabs custom-nav-class="container" @before-change="beforeChange" @after-change="afterChange">

    <b-tab id="beginner" htmlTitle :title="$t('home.demo.new.title')" :tab-classes="{'beginner col-md-4 col-sm-5 col-md-offset-4 col-sm-offset-4':true}">
      <div class="container">
        <p class="instruction" v-html="$t('home.demo.new.description')"></p>
        <DemoWidget/>
      </div>
    </b-tab>
    <!--
    <b-tab id="experienced" htmlTitle :title="$t('home.demo.experienced.title')" :tab-classes="{'experienced col-md-4 col-sm-5':true}">
      <div class="container">
        <p class="instruction" v-html="$t('home.demo.experienced.description')"></p>
        <div class="features-widget">
          <div class="container">
            <div class="platform-screenshot">
              <img class="browser"
                data-src="@/assets/images/mockup-flat-lg_new.png"
                src="@/assets/images/mockup-flat-lg_new.png">

              <div class="feature-spot range-of-options">
                <div class="spot">
                </div>
                <div class="wire left">
                  <img data-src="@/assets/images/wire-option-types.png"
                    src="@/assets/images/wire-option-types.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.option-type')"></div>
                </div>
              </div>

              <div class="feature-spot industry-best-payouts">
                <div class="spot">
                </div>
                <div class="wire left">
                  <img data-src="@/assets/images/wire-best-payouts.png"
                    src="@/assets/images/wire-best-payouts.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.payout')"></div>
                </div>
              </div>
              <div class="feature-spot rich-interface">
                <div class="spot">
                </div>
                <div class="wire left">
                  <img data-src="@/assets/images/wire-rich-interface.png"
                    src="@/assets/images/wire-rich-interface.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.interface')"></div>
                </div>
              </div>
              <div class="feature-spot heat-map">
                <div class="spot">
                </div>
                <div class="wire left">
                  <img data-src="@/assets/images/wire-heat-map.png"
                    src="@/assets/images/wire-heat-map.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.heat-map')"></div>
                </div>
              </div>

              <div class="feature-spot loyalty-cash-back">
                <div class="spot">
                </div>
                <div class="wire diagonal">
                  <img data-src="@/assets/images/wire-loyalty-cashback.png"
                    src="@/assets/images/wire-loyalty-cashback.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.cashback')"></div>
                </div>
              </div>
              <div class="feature-spot quick-deposit">
                <div class="spot">
                </div>
                <div class="wire diagonal">
                  <img data-src="@/assets/images/wire-quick-deposit.png"
                    src="@/assets/images/wire-quick-deposit.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.deposit')"></div>
                </div>
              </div>
              <div class="feature-spot options-watch-list">
                <div class="spot">
                </div>
                <div class="wire diagonal">
                  <img data-src="@/assets/images/wire-watch-list.png"
                    src="@/assets/images/wire-watch-list.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.watchlist')"></div>
                </div>
              </div>
              <div class="feature-spot one-touch-trading">
                <div class="spot">
                </div>
                <div class="wire">
                  <img data-src="@/assets/images/wire-one-touch.png"
                    src="@/assets/images/wire-one-touch.png">
                  <div class="feature-spot-label" v-html="$t('home.demo.experienced.features.one-click')"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="bait">
            <a class="js-signup-trigger" v-html="$t('home.demo.experienced.cta')"></a>
            <a class="full-demo-bait" v-html="$t('home.demo.experienced.quick-demo')"></a>
          </div>
        </div>
      </div>
    </b-tab>-->

  </b-tabs>
</template>

<script>
import {addClass, removeClass} from '@/utils/domUtils';
import DemoWidget from '@/components/animations/DemoWidget'

export default {
  components: {DemoWidget},
  mounted: function () {
    this.$nextTick(function () {
      let tabs = this.$el.__vue__.tabs;
      addClass(tabs[0].$el,'showed');
    })
  },
  methods : {
    beforeChange(indexFrom, indexTo, done) {
      let tabs = this.$el.__vue__.tabs;
      removeClass(tabs[indexFrom].$el,'showed');
      done();
    }, 
    afterChange(index) {
      let tab = this.$el.__vue__.tabs[index];
      addClass(tab.$el,'showed');
    }
  }
}
</script>